/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SubscriptionsControllerCancelAllSubscriptions$Params {
  customerId: string;
}

export function subscriptionsControllerCancelAllSubscriptions(http: HttpClient, rootUrl: string, params: SubscriptionsControllerCancelAllSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, subscriptionsControllerCancelAllSubscriptions.PATH, 'delete');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

subscriptionsControllerCancelAllSubscriptions.PATH = '/keus-payments/subscriptions/{customerId}/subscriptions';
